import {CommonModule} from '@angular/common';
import {afterNextRender, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {PipesModule} from '../../core/pipes/pipes.module';
import {ImagePalette, ImagePaletteService} from './image-palette.service';

@Component({
  selector: '[appHeaderBackdrop]',
  standalone: true,
  imports: [CommonModule, PipesModule],
  host: {'[class.header-backdrop-host]': '!!appHeaderBackdrop'},
  templateUrl: './header-backdrop.component.html',
  styleUrls: ['./header-backdrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBackdropComponent implements OnChanges, OnDestroy {
  @Input() appHeaderBackdrop: string | null | undefined;
  @Input() backdropMode: 'blur' | 'gradient' = 'blur';

  public loadedUrl: string | null = null;
  public palette: ImagePalette | null = null;
  private failedUrl: string | null = null;
  private browserRendered = false;
  private paletteRequest = 0;

  constructor(private readonly palettes: ImagePaletteService, private readonly cdr: ChangeDetectorRef) {
    afterNextRender(() => {
      this.browserRendered = true;
      this.updatePalette();
    });
  }

  public ngOnChanges(): void {
    this.loadedUrl = null;
    this.failedUrl = null;
    this.palette = null;
    this.updatePalette();
  }

  public ngOnDestroy(): void {
    this.paletteRequest++;
  }

  public get backdropUrl(): string | null {
    return this.appHeaderBackdrop && this.appHeaderBackdrop !== this.failedUrl ? this.appHeaderBackdrop : null;
  }

  public onBackdropLoad(url: string): void {
    if (url === this.appHeaderBackdrop) this.loadedUrl = url;
  }

  public onBackdropError(url: string): void {
    if (url === this.appHeaderBackdrop) this.failedUrl = url;
  }

  private updatePalette(): void {
    const request = ++this.paletteRequest;
    if (!this.browserRendered || this.backdropMode !== 'gradient' || !this.appHeaderBackdrop) return;
    this.palettes.getPalette(this.appHeaderBackdrop).then(palette => {
      if (request !== this.paletteRequest) return;
      this.palette = palette;
      this.cdr.markForCheck();
    });
  }
}
